import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ui-modal',
  templateUrl: './modal.component.html',
  standalone: false
})
export class UiModalComponent {
  @Input() open = false;
  @Input() width = '320px';
  @Output() closed = new EventEmitter<void>();

  onBackdropClick(): void {
    this.closed.emit();
  }
}
